export const FORM_TYPE_EXTENDED_WORKSHOP = 'extended-workshop'
export const FORM_TYPE_EXTENDED_FORM2 = 'extended-form2'
/** Unmasking Patterns half-day: age, gender, company, session tier, UPI payment, transaction ID, facilitator questions */
export const FORM_TYPE_UNMASKING_HALFDAY_APR2026 = 'unmasking-halfday-apr2026'
export const FORM_TYPE_A_WAY_TO_MOVE = 'a-way-to-move'

export const A_WAY_TO_MOVE_SLOT_OPTIONS = [
  { value: 'Tuesday May 5, 2026', weekday: 'Tuesday', label: 'May 5', date: '2026-05-05' },
  { value: 'Thursday May 7, 2026', weekday: 'Thursday', label: 'May 7', date: '2026-05-07' },
  { value: 'Tuesday May 12, 2026', weekday: 'Tuesday', label: 'May 12', date: '2026-05-12' },
  { value: 'Thursday May 14, 2026', weekday: 'Thursday', label: 'May 14', date: '2026-05-14' },
  { value: 'Tuesday May 19, 2026', weekday: 'Tuesday', label: 'May 19', date: '2026-05-19' },
  { value: 'Thursday May 21, 2026', weekday: 'Thursday', label: 'May 21', date: '2026-05-21' },
  { value: 'Tuesday May 26, 2026', weekday: 'Tuesday', label: 'May 26', date: '2026-05-26' },
  { value: 'Thursday May 28, 2026', weekday: 'Thursday', label: 'May 28', date: '2026-05-28' },
]

export const getAvailableAWayToMoveSlotOptions = (now = new Date()) =>
  A_WAY_TO_MOVE_SLOT_OPTIONS.filter((slot) => {
    const slotEndOfDayIst = new Date(`${slot.date}T23:59:59.999+05:30`)
    return slotEndOfDayIst >= now
  })

export const UNMASKING_SESSION_OPTIONS = [
  { value: 'Session 1 (₹1,200)', subtitle: 'Inner Balance through Art · 10:00 AM – 11:30 AM' },
  { value: 'Session 2 (₹1,200)', subtitle: 'Rewiring Your Relational Patterns · 12:00 PM – 1:30 PM' },
  { value: 'Full Day (₹1,999)', subtitle: 'Both sessions' },
]

export const UNMASKING_GENDER_OPTIONS = ['Female', 'Male', 'Non-binary', 'Prefer not to say', 'Other']

export const needsExtendedForm2 = (event) => event?.formType === FORM_TYPE_EXTENDED_FORM2
export const needsUnmaskingHalfdayApr2026Form = (event) =>
  event?.formType === FORM_TYPE_UNMASKING_HALFDAY_APR2026
export const needsAWayToMoveForm = (event) => event?.formType === FORM_TYPE_A_WAY_TO_MOVE
